/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHomeLg} from '@fortawesome/pro-duotone-svg-icons';

const FamilyIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faHomeLg} {...props} />
);

export default FamilyIcon;
